export default {
    namespace: 'AIFamily',
    translations: {
        zh: {
            hero: {
                kicker: 'AI AGENT PLATFORM',
                title: '招聘、求职、管理发展一体化平台',
                subtitle: '可实现人才发现、智能评估到精准匹配、闭环管理',
                comingSoon: '正在制作中',
                imageAlt: 'AI Agent 虚拟形象'
            }
        },
        en: {
            hero: {
                kicker: 'AI AGENT PLATFORM',
                title: 'An Integrated Platform for Hiring, Job Seeking, Management, and Development',
                subtitle: 'From talent discovery and intelligent assessment to precise matching and closed-loop management',
                comingSoon: 'Coming Soon',
                imageAlt: 'AI Agent Virtual Character'
            }
        },
        ja: {
            hero: {
                kicker: 'AI AGENT PLATFORM',
                title: '採用・求職・管理育成を一体化するプラットフォーム',
                subtitle: '人材発見、智能評価、精密マッチングからクローズドループ管理までを実現',
                comingSoon: '制作中です',
                imageAlt: 'AIエージェントのバーチャルイメージ'
            }
        }
    }
};
